export enum QuizMode {
  QUIZ = 'QUIZ',
  POLL = 'POLL',
  OPEN = 'OPEN',
}
